import type { FaireProductEntity } from "../../entity_types/product";

export const p_vuwg746xnn: FaireProductEntity = {
  token: "p_vuwg746xnn",
  type: "product",
  name: "Afterglow Ceramic Handmade Mug - 16oz",
  brandToken: "b_7jc8fy9bgs",
  brandName: "Nova Ceramics Travel Mugs",
  imageUrl:
    "https://cdn.faire.com/fastly/8f598c50829d6b9dc5dc66d62505b98cb4728ee11ea371832a91b6c9b3a45167.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4bbfba7aafe2c060a705c42ea966798bd49c7c843ce2c3612457a28a78bda4a4.jpeg",
    "https://cdn.faire.com/fastly/d4b5476846f8157755ebc49eb15a3db10d93f62d9fc5056422087d561341fcb8.jpeg",
    "https://cdn.faire.com/fastly/67cfdfa1a5fe24bd786709a3543cedda38da1a232a4aef8196bdd7d77a588539.jpeg",
    "https://cdn.faire.com/fastly/6111a4cd17fb0fceb2f60c1a2364297398e892c85d5ac07744a9800f9f6fd284.jpeg",
    "https://cdn.faire.com/fastly/2433ae97ea0af7980fb5f4a8eba19157a2dff80868595085dc39986a1395c4df.jpeg",
    "https://cdn.faire.com/fastly/af2d483b67190f694bd21fc11da7ecf47effd7bac23df4c8ff38a97cf9d5a774.jpeg",
    "https://cdn.faire.com/fastly/72c86b04b838d3c366de1954c2427bf99b1d99ca90f4f76af6fce8ddd0cb3a91.jpeg",
    "https://cdn.faire.com/fastly/76229635eb1d7c1de159e4d9499231e517656478bbf5062b121cfcae8abd56e8.jpeg",
  ],
  priceDollars: 28,
  description:
    "Sip back and enjoy the sunset. Pink, light yellow, and orange blend harmoniously into a soothing light grey base, reminiscent of the sky’s soft glow at dusk.\n\nEach of our handglazed cups and mugs turn your morning sip into a mindful pause, while enhancing the aroma of your favorite drink. Hand-glazed with a one-of-a-kind motif, no two mugs are exactly alike.\n\nPerfect for slow mornings or cozy afternoons, our handmade mug is crafted from high-quality stoneware to deliver the purest taste with every sip. Its oversized, easy-hold handle is thoughtfully designed to feel balanced and secure in your hand, making every coffee moment feel comfortable and effortless.\n\nCapacity: 16 ounces / 475ml Size: 3.14 x 4.3 Inches / 8 x 11cm\n\n- Premium stoneware ceramic for durability and pure flavour\n- Oversized, comfortable handle for an easy grip\n- A beautiful statement piece, perfect for gifting\n- Microwave Safe & Dishwasher Safe",
  tags: [],
  msrpDollars: 56,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-19T21:22:51.925Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
